import React, { createContext, useContext, useState, useEffect } from 'react';

const ReservationContext = createContext();

export const useReservation = () => useContext(ReservationContext);

const SESSION_STORAGE_KEY = 'reservation';

const defaultReservation = {
  checkIn: '',
  checkOut: '',
  nights: 0,
  rooms: [],
  contact: {},
  payment: {},
  total: 0,
  currency: 'USD',
};

export const ReservationProvider = ({ children }) => {
  const [reservation, setReservation] = useState(() => {
    try {
      const stored = sessionStorage.getItem(SESSION_STORAGE_KEY);
      return stored ? JSON.parse(stored) : defaultReservation;
    } catch (err) {
      console.error('Error loading reservation from sessionStorage:', err);
      return defaultReservation;
    }
  });

  // Save changes to sessionStorage
  useEffect(() => {
    try {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(reservation));
    } catch (err) {
      console.error('Error saving reservation to sessionStorage:', err);
    }
  }, [reservation]);

  // Optional: Add reset function
  const clearReservation = () => {
    setReservation(defaultReservation);
    sessionStorage.removeItem(SESSION_STORAGE_KEY);
  };

  return (
    <ReservationContext.Provider
      value={{ reservation, setReservation, clearReservation }}
    >
      {children}
    </ReservationContext.Provider>
  );
};
